/*
 * @Author: zhangshengwei
 */
import Vue from "vue";
import Vuex from "vuex";
import { getInfo, getSeason } from "@/api/login";
import { getDictData } from "@/api/home";
Vue.use(Vuex);
const state = {
  // 要设置的全局访问的state对象
  activeRegionObj: {
    areaCode: "",
    areaName: "",
    parentCode: "",
  },
  socializationFold: false, //社会化服务收起展开
  activeYear: "", // 政务年份选择
  pageLeftFold: true, // 页面左侧是否收起
  pageRrigtFold: true, // 页面右侧是否收起
  lastAddreassName: "", // 最后一级地址名称
  user: null,
  roles: [],
  permissions: [], // 用户权限
  dvPermissions: [], // 大屏权限
  dvPermissionsReady: false,
  deptAreaCode: null, // 用户所在机构
  areaPermissionsSetting: [], // 区域配置权限
  permiParentDomArr: [], // 按钮权限父级dom存储，防止removeChild找不到对应父级，key为权限，node为dom
  machineryType: 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理类机械 7其他机械
  machineryType: "1", // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理类机械 7其他机械
  season: null, // SX三夏 SQ三秋
};
const getters = {
  // 实时监听state值的变化(最新状态)
  season(state) {
    return state.season;
  },
  getActiveYear(state) {
    return state.activeYear;
  },
  // 当前选中的农机品类，「智慧AI高度」tab 要用这个
  getMachineryType(state) {
    return state.machineryType;
  },
  getactiveRegionObj(state) {
    return state.activeRegionObj;
  },
  getLeftFold(state) {
    return state.pageLeftFold;
  },
  getRightFold(state) {
    return state.pageRrigtFold;
  },
  getLastAddreassName(state) {
    return state.lastAddreassName;
  },
  getLastPreAddreassName(state) {
    return state.lastPreAddreassName;
  },
  roles: (state) => state.roles || [],
  permissions: (state) => [...state.permissions, ...state.dvPermissions],
  // 获取当前登录用户所在机构所在区域code
  getUserDeptAreaCode(state) {
    return state.deptAreaCode;
  },
  // 区域权限配置
  getAreaPermissionsSetting(state) {
    return state.areaPermissionsSetting;
  },
  // 获取权限父级dom存储
  getHasPermiDom: (state, status) => {
    return state.permiParentDomArr;
  },
  // 社会化服务收起展开
  getSocializationFold(state) {
    return state.socializationFold;
  },
};
const mutations = {
  // 设置权限父级dom存储
  setHasPermiDom: (state, status) => {
    state.permiParentDomArr = status;
  },
  SET_USER_DEPT_AREACODE: (state, status) => {
    state.deptAreaCode = status;
  },
  SET_AREA_PERMISSIONS_SETTING: (state, status) => {
    state.areaPermissionsSetting = status;
  },
  // SX三夏 SQ三秋
  SET_SEASON(state, v) {
    state.season = v;
  },
  setActiveYear(state, name) {
    state.activeYear = name;
  },
  // 当前选中的农机品类，「智慧AI高度」tab 要用这个
  setMachineryType(state, v) {
    state.machineryType = v;
  },
  // 社会化折叠
  setSocializationFold(state, status) {
    state.socializationFold = status;
  },
  setactiveRegionObj(state, name) {
    state.activeRegionObj = name;
  },
  setLeftFold(state, status) {
    state.pageLeftFold = status;
  },
  setRightFold(state, status) {
    state.pageRrigtFold = status;
  },
  setLastAddreassName(state, status) {
    state.lastAddreassName = status;
  },
  setLastPreAddreassName(state, status) {
    state.lastPreAddreassName = status;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_DV_PERMISSIONS: (state, permissions) => {
    state.dvPermissions = permissions || [];
  },
  SET_DV_PERMISSIONS_READY: (state, ready) => {
    state.dvPermissionsReady = ready;
  },
};
const actions = {
  setactiveRegionObj(context, val) {
    context.commit("setactiveRegionObj", val);
  },
  setLeftFold(context, status) {
    context.commit("setLeftFold", status);
  },
  setRightFold(context, status) {
    context.commit("setRightFold", status);
  },
  setLastAddreassName(context, status) {
    context.commit("setLastAddreassName", status);
  },
  // 社会化折叠
  setSocializationFold(context, status) {
    context.commit("setSocializationFold", status);
  },
  setActiveYear(context, val) {
    context.commit("setActiveYear", val);
  },
  setLastPreAddreassName(context, status) {
    context.commit("setLastPreAddreassName", status);
  },
  // 获取用户信息
  GetInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({ type: "web", _unpack: true })
        .then((response) => {
          console.log("GetInfo.response::", response);
          const res = response || {};
          commit("SET_USER", res.user || null);
          commit("SET_PERMISSIONS", res.permissions || []);
          commit("SET_ROLES", res.roles || ["ROLE_DEFAULT"]);
          commit("SET_USER_DEPT_AREACODE", res.user.dept.areaCode);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取区域配置权限
  getAreaPermissionsSetting({ commit, state }) {
    return new Promise((resolve, reject) => {
      getDictData("screen_area_permissions_setting")
        .then((response) => {
          const res = response || {};
          commit("SET_AREA_PERMISSIONS_SETTING", res || []);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取季度类型（返回SX三夏 SQ三秋）
  GetSeason({ commit, state }) {
    return new Promise((resolve, reject) => {
      getSeason()
        .then((response) => {
          // console.log('%c季度类型::', 'color:#CC0', response);
          commit("SET_SEASON", response || null);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});
export default store;
